import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from "@/components/uploadImagetow";
import { mapState } from "vuex";
import { vipEmailsTemplateAdd, vipEmailsTemplateUpdate } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewCom, gmToolNewPage } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom, gmToolNewPage],
  components: {
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    var _this = this;

    var validateuids = function validateuids(rule, value, callback) {
      var regex = /[\u4e00-\u9fa5，]/;

      if (regex.test(value) || !value) {
        callback(new Error(_this.$t('roleIdIncorrect')));
      } else {
        callback();
      }
    };

    return {
      type: 0,
      paramsData: {
        type: "to_users",
        template_name: '',
        title: "",
        context: "",
        reward: [],
        sender: "",
        language: "",
        id: "",
        delay_state: 2,
        expire: null
      },
      dialogShow: false,
      emailType: [{
        label: this.$t('sendToAll'),
        value: "all"
      }, {
        label: this.$t('sendToTargetAccount'),
        value: "to_users"
      }],
      timing: [{
        label: this.$t('no'),
        value: 2
      }, {
        label: this.$t('yes'),
        value: 1
      }],
      timingType: 2,
      currencyItemList: [],
      equipmentItemList: [],
      rules: {
        template_name: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        sender: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: this.$t('pleaseEnterTitle'),
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: this.$t('pleaseSelectLanguage'),
          trigger: "blur"
        }],
        context: [{
          required: true,
          message: this.$t('pleaseEnterContent'),
          trigger: "blur"
        }],
        expire: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        item_type: [{
          required: true,
          message: this.$t('pleaseSelectItemType'),
          trigger: "blur"
        }],
        id: [{
          required: true,
          message: this.$t('pleaseSelectItem'),
          trigger: "blur"
        }],
        item_num: [{
          required: true,
          message: this.$t('pleaseEnterQuantity'),
          trigger: "blur"
        }],
        item_quality: [{
          required: true,
          message: this.$t('pleaseSelectItemQuality'),
          trigger: "blur"
        }],
        textid: [{
          required: true,
          message: this.$t('itemId'),
          trigger: "blur"
        }],
        server_id: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        star: [{
          required: true,
          message: this.$t('pleaseEnterStarLevel'),
          trigger: "blur"
        }]
      },
      isSend: false,
      isPermissions: false
    };
  },
  created: function created() {},
  methods: {
    open: function open(data, uids) {
      var _this2 = this;

      var isPermissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.itemType.map(function (i) {
        _this2['itemType' + i.value] = _this2.szgmItemList.filter(function (item) {
          return item.type == i.value;
        });
      });
      var d = {
        method: "",
        id: data.id || "",
        title: data.title || "",
        context: data.content || "",
        reward: [],
        language: data.language,
        expire: data.expire,
        sender: data.sender,
        template_name: data.template_name,
        type: data.email_type !== 0 ? data.email_type == 1 ? "all" : "to_users" : ""
      };
      d.reward = data.reward ? JSON.parse(data.reward) : [];
      d.reward.map(function (item) {
        var str = JSON.stringify(item.id);

        var index = _this2.szgmItemList.findIndex(function (j) {
          return j.id == str;
        });

        item.id = index > -1 ? str : '';
        item.textid = index > -1 ? '' : str;
        item.type = index > -1 ? Number(_this2.szgmItemList[index].type) : item.type;
      });
      this.paramsData = _objectSpread(_objectSpread({}, this.paramsData), d);
      this.dialogShow = true;
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        method: "",
        id: isClearId ? "" : this.paramsData.id,
        title: "",
        context: "",
        reward: [],
        sender: "",
        language: "",
        template_name: '',
        type: this.isSend || this.isPermissions ? "to_users" : "all",
        expire: this.$times.timestampToTime((new Date(this.$times.zeroTimeZone()).getTime() + 3600 * 1000 * 24 * 7) / 1000, "YY-MM-DD HH:II:SS")
      };
      this.serverListYJ = [];
      this.$refs.ruleForm.clearValidate();
    },
    itemChange: function itemChange(index, type) {
      this.paramsData.reward[index][type == 'ITEM' ? 'textid' : 'id'] = '';
    },
    addtag: function addtag(data) {
      this.paramsData.context = "".concat(this.paramsData.context).concat(data);
    },
    addDomain: function addDomain() {
      this.paramsData.reward.push({
        num: "",
        type: "",
        id: "",
        textid: "",
        quality: "",
        star: 0
      });
    },
    removeDomain: function removeDomain(item) {
      var index = this.paramsData.reward.indexOf(item);

      if (index !== -1) {
        this.paramsData.reward.splice(index, 1);
      }
    },
    domainType: function domainType(index, type) {
      this.paramsData.reward[index].id = "";
      this.paramsData.reward[index].textid = "";

      if (this.paramsData.reward[index].num) {
        this.paramsData.reward[index].num = '';
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm(_this3.$t('confirmSubmit'), _this3.$t('prompt'), {
            confirmButtonText: _this3.$t('confirm'),
            cancelButtonText: _this3.$t('cancel'),
            type: "warning",
            beforeClose: function beforeClose(action, instance, done) {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                var data = JSON.parse(JSON.stringify(_this3.paramsData));
                data.reward.map(function (item) {
                  item.id = item.id == '' ? item.textid : item.id;
                  delete item.textid;

                  if (item.type == 1) {
                    delete item.quality;
                  }

                  if (!item.quality) {
                    delete item.quality;
                  }

                  if (item.type != 2) {
                    delete item.star;
                  }

                  for (var i in item) {
                    item[i] = parseInt(item[i]);
                  }
                });
                data.reward = _this3.isPermissions ? "[]" : JSON.stringify(data.reward);
                var reqFn = data.id ? vipEmailsTemplateUpdate : vipEmailsTemplateAdd;
                reqFn(_objectSpread(_objectSpread({}, data), {}, {
                  env_id: _this3.propsData.env_id,
                  game_id: _this3.rawData.game_id
                })).then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (res.code == 200) {
                              _this3.$message({
                                message: _this3.$t('operationSuccess'),
                                type: "success"
                              });

                              _this3.$emit('change');

                              done();
                              _this3.dialogShow = false;
                              instance.confirmButtonLoading = false;
                            } else {
                              done();
                              instance.confirmButtonLoading = false;
                            }

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
              } else {
                done();
                instance.confirmButtonLoading = false;
              }
            }
          });
        }
      });
    }
  }
};